import React from "react";
import { useTranslation } from "react-i18next";
import Eyebrow from "../../atoms/Eyebrow/Eyebrow.styled";
import Button from "../../atoms/Button/Button.component";
import PlanCard from "../../atoms/PlanCard/PlanCard.component";
import { ButtonVariant } from "../../atoms/Button/Button.styled";
import { useDemoDialog } from "../../molecules/DemoDialog/DemoDialog.context";
import {
  getPlansTranslated,
  getSummitPackageTranslated,
} from "../../../constants/plans";
import { newLineText } from "../../../utils/utils";
import {
  PlansFineprint,
  PlansGrid,
  PlansHead,
  PlansLead,
  PlansSection,
  PlansTitle,
  PlansWrapper,
  SummitCopy,
  SummitEyebrow,
  SummitPrice,
  SummitStrip,
  SummitTitle,
} from "./Plans.styled";

const Plans = () => {
  const { t } = useTranslation();
  const { openDemoDialog } = useDemoDialog();
  const plans = getPlansTranslated(t);
  const summit = getSummitPackageTranslated(t);

  return (
    <PlansSection id="pricing" aria-labelledby="pricing-title">
      <PlansWrapper>
        <PlansHead>
          <Eyebrow>{t("landing.plans.eyebrow")}</Eyebrow>
          <PlansTitle id="pricing-title">
            {newLineText(t("landing.plans.title")).map((line) => (
              <span key={line}>{line}</span>
            ))}
          </PlansTitle>
          <PlansLead>{t("landing.plans.description")}</PlansLead>
        </PlansHead>
        <PlansGrid>
          {plans.map((plan) => (
            <PlanCard
              key={plan.id}
              featured={plan.featured}
              kicker={plan.kicker}
              name={plan.name}
              price={plan.price}
              unit={plan.unit}
              description={plan.description}
              features={plan.features}
              note={plan.note}
              cta={plan.cta}
              onRequestDemo={openDemoDialog}
            />
          ))}
        </PlansGrid>
        <SummitStrip>
          <SummitCopy>
            <SummitEyebrow>{summit.eyebrow}</SummitEyebrow>
            <SummitTitle>{summit.name}</SummitTitle>
            <p>{summit.description}</p>
          </SummitCopy>
          <SummitPrice>
            <strong>{summit.price}</strong>
            <span>{summit.unit}</span>
          </SummitPrice>
          <Button
            variant={summit.cta.variant as ButtonVariant}
            onClick={() => openDemoDialog(summit.cta.plan)}
          >
            {summit.cta.label}
          </Button>
        </SummitStrip>
        <PlansFineprint>
          <span>{t("landing.plans.fineprintOne")}</span>
          <span>{t("landing.plans.fineprintTwo")}</span>
        </PlansFineprint>
      </PlansWrapper>
    </PlansSection>
  );
};

export default Plans;
